import { useNavigate } from "react-router-dom";
import { ForgotPasswordForm as UIForgotPasswordForm } from "@racoon/ui";
import { useRequestOTPMutation, useForgotPasswordViaOtpMutation } from "~/shared/api/auth/auth.grpc";

export const ForgotPasswordForm = () => {
  const navigate = useNavigate();
  const requestOtpMutation = useRequestOTPMutation();
  const forgotPasswordMutation = useForgotPasswordViaOtpMutation();

  const handleSuccess = () => {
    navigate("/login");
  };

  return (
    <UIForgotPasswordForm
      sendOtpMutation={requestOtpMutation as any}
      resetPasswordMutation={forgotPasswordMutation as any}
      onSuccess={handleSuccess}
      onNavigateToLogin={() => navigate("/login")}
      onNavigateToSmsLogin={() => navigate("/login?method=sms")}
      isGrpc={true}
    />
  );
};
